/*
 * commodities Reducer
 */
import get from 'lodash.get';

import { SCAFFOLD_DATA_LOAD_SUCCEEDED } from '../scaffoldData/constants';
import { RESET_STATE } from '../auth/constants';
import { COMMODITIES_REMOVE, COMMODITIES_SET } from './constants';
import { CommoditiesActions, CommoditiesState } from './types';

const initialState = {};

export default function (
    state: CommoditiesState = initialState,
    action: CommoditiesActions
) {
    switch (action.type) {
        case SCAFFOLD_DATA_LOAD_SUCCEEDED:
            return get(action, 'payload.entities.commodities', {});
        case COMMODITIES_SET:
            return {
                ...state,
                ...action.payload
            };
        case COMMODITIES_REMOVE: {
            const { ids } = action.payload;
            const clonedState = { ...state };

            ids.forEach((id) => delete clonedState[id]);

            return clonedState;
        }
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
